module.exports = __webpack_public_path__ + "img/sld_scb_8_t1_b1_dark.b6152e6e.svg";